export default "__VITE_ASSET__tP6uR9KH__"